var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 5.137a.5.5 0 0 0-.708.02l.363.343-.363-.344v.001l-.003.003-.011.011-.045.048-.197.208-.914.964-4.66 4.919c-.364.383-.371.99-.003 1.378l5.833 6.156a.5.5 0 1 0 .726-.688L3.658 12.5H21a.5.5 0 0 0 0-1H3.659l4.189-4.421.914-.964.196-.208.046-.048.01-.011.003-.003.001-.001-.363-.344.363.344A.5.5 0 0 0 9 5.137",
    clipRule: "evenodd"
  })));
});
const SvgArrowLeft = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljk5OTA2IDUuMTM3MDZDOC43OTg2MSA0Ljk0NzEyIDguNDgyMTUgNC45NTU2NSA4LjI5MjIxIDUuMTU2MUw4LjY1NTE2IDUuNUw4LjI5MjIgNS4xNTYxMUw4LjI5MjE2IDUuMTU2MTVMOC4yOTIgNS4xNTYzMkw4LjI5MTM0IDUuMTU3MDJMOC4yODg2OSA1LjE1OTgxTDguMjc3ODYgNS4xNzEyNEw4LjIzMjU2IDUuMjE5MDZMOC4wMzU2MSA1LjQyNjlMNy4xMjIwMyA2LjM5MTA3TDIuNDYxMjIgMTEuMzA5OUMyLjA5ODQ4IDExLjY5MjggMi4wOTA4OCAxMi4yOTkyIDIuNDU5MDggMTIuNjg3OEw4LjI5MjIxIDE4Ljg0MzlDOC40ODIxNSAxOS4wNDQ0IDguNzk4NjEgMTkuMDUyOSA4Ljk5OTA2IDE4Ljg2MjlDOS4xOTk1MSAxOC42NzMgOS4yMDgwNCAxOC4zNTY1IDkuMDE4MSAxOC4xNTYxTDMuNjU4NzQgMTIuNUgyMUMyMS4yNzYxIDEyLjUgMjEuNSAxMi4yNzYxIDIxLjUgMTJDMjEuNSAxMS43MjM5IDIxLjI3NjEgMTEuNSAyMSAxMS41SDMuNjU4NzRMNy44NDc5MiA3LjA3ODg4TDguNzYxNSA2LjExNDcxTDguOTU4NDUgNS45MDY4N0w5LjAwMzc1IDUuODU5MDVMOS4wMTQ1OSA1Ljg0NzYyTDkuMDE3MjMgNS44NDQ4Mkw5LjAxNzg5IDUuODQ0MTNMOS4wMTgwNSA1Ljg0Mzk2TDkuMDE4MDkgNS44NDM5Mkw4LjY1NTE2IDUuNUw5LjAxODEgNS44NDM5MUM5LjIwODA0IDUuNjQzNDYgOS4xOTk1MSA1LjMyNjk5IDguOTk5MDYgNS4xMzcwNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";